import { render, staticRenderFns } from "./ScoreIndicator.vue?vue&type=template&id=55f44113&scoped=true"
import script from "./ScoreIndicator.vue?vue&type=script&lang=ts"
export * from "./ScoreIndicator.vue?vue&type=script&lang=ts"
import style0 from "./ScoreIndicator.vue?vue&type=style&index=0&id=55f44113&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f44113",
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QChip});
